
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gMdoZ3ErW3XFDLPRAnt38d_45a_457UU4q3K8mN_45M8_21zRkMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexhOeSQnloF1ghvowleHWZzBKQU6FHZ8NL6zofotS3wHsMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchg7WwiPiKKJUPhbvGkvcQMGREymC0m2T2rfL9MuCsyKsMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexOjntQGk6zKyJj_459wpiOTrmCQohsmd63YnaxL33_T6ygMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93P0XyatYKh62yG2RDiF5TI8tis6_4iYeFf65ECYWp2qoMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexYlfwc320U2guAGFRiFc4eWl3zMOtrePyX9VQaBAV8BAMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93CxmnLxbysJRB3ImS5eRLISAtfp5TtoXFe6zgGCYy1JMMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index3ZlbnNWwjRGRQcoCWQt7PtUTeyB4plb8IyaYjVfnv6cMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93076z8k1np5zceBmR4Qof0dc6pT1PJKNFmtPghxqMs8MMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexdd5DtUFUJGB0cgoAYhJO9JQwMyxA6zRfHHSyehau_45goMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexaaGHyZj2Q3wyFVHCON_45SSknEDeGrldi6OxXUS_453ZEwwMeta } from "/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexYlfwc320U2guAGFRiFc4eWl3zMOtrePyX9VQaBAV8BAMeta || {},
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index3ZlbnNWwjRGRQcoCWQt7PtUTeyB4plb8IyaYjVfnv6cMeta || {},
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexdd5DtUFUJGB0cgoAYhJO9JQwMyxA6zRfHHSyehau_45goMeta || {},
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexaaGHyZj2Q3wyFVHCON_45SSknEDeGrldi6OxXUS_453ZEwwMeta || {},
    component: () => import("/codebuild/output/src4247945906/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]